<div class="title" translate>MEDIA.BACS.TITLE_MINE</div>
<ng-container *ngIf="currentRadioId$ | async as radioId">
  <div class="list">
    <ng-container *ngFor="let group of bacsGroups$ | async">
      <ng-container *ngFor="let box of group.boxes; let i = index">
        <a
          class="link"
          [routerLink]="['/radio/' + radioId + '/media/' + box.url]"
          (click)="clickBox()"
          (touchstart)="onTouch(i)"
          (touchmove)="onTouchEnd()"
          (touchend)="onTouchEnd()"
          [class.touched]="$touched() === i"
        >
          <mat-icon fontSet="fa" [fontIcon]="box.icon" class="bac-icon"></mat-icon>
          <span>{{ box.translated$ | async }}</span>
          <span class="link-count">{{ box.count }}</span>
        </a>
      </ng-container>
    </ng-container>
  </div>
  @if ((allPlaylists$ | async).length > 0) {
    <div class="title" translate>MEDIA.PLAYLISTS.TITLE_MINE</div>
    <rk-search-bar (inputted)="search($event)" [type]="'full'"></rk-search-bar>
  }
  <div class="list pb-8">
    @for (playlist of playlists; track playlist; let i = $index) {
      <a
        class="link"
        routerLink="/radio/{{ radioId }}/media/playlist/{{ playlist.id }}"
        (click)="clickBox()"
        (touchstart)="onTouch(i + 10)"
        (touchmove)="onTouchEnd()"
        (touchend)="onTouchEnd()"
        [class.touched]="$touched() === i + 10"
      >
        <rk-playlist-icon [playlist]="playlist"></rk-playlist-icon>
        <span class="ellipsis">{{ playlist.name }}</span>
        <span class="link-count">{{ playlist.nbTracks }}</span>
      </a>
    }
  </div>
  <div class="add-playlist-container fixed bottom-0 left-0 w-full bg-white p-3">
    <rk-button
      class="w-full"
      (click)="createPlaylist()"
      [fullWidth]="true"
      [label]="'CHECKLIST.PLAYLISTS.ADD_PLAYLIST' | translate"
    ></rk-button>
  </div>
</ng-container>
